import styles from './DeletePopup.module.css';
import { useState } from 'react';

import SimpleLoader from '../../../../Components/SimpleLoader/SimpleLoader';

import { deleteUserPersonal } from '../../../../Api/Backend/User';
import { useAuth } from '../../../../Context/AuthContext';


function DeletePopup({ onClose }) {
    const auth = useAuth();
    const { logout } = auth;

    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);

    const handleDeleteUserProfile = async () => {
        setIsLoading(true);

        await deleteUserPersonal({
            auth: auth,
            onSuccess: () => {
                alert("계정이 성공적으로 삭제되었습니다.");
                logout();
            },
            onError: (error) => {
                setErrorMessage(error.message || "계정 삭제 실패: " + error);
            }
        });

        setIsLoading(false);
    };

    return (
        <div className={styles.deletePopup}>
            <div className={styles.header}>
                <label>계정 삭제</label>
                <div
                    className={styles.closeButton}
                    onClick={onClose}>
                    <img src="./images/close_icon_30.png" />
                </div>
            </div>

            <div className={styles.popupContainer}>
                {isLoading ? (
                    <div className={styles.loader}>
                        <SimpleLoader />
                    </div>
                ) : (
                    <>
                        <p>이 작업은 되돌릴 수 없습니다!</p>
                        <button
                            type="button"
                            onClick={handleDeleteUserProfile}
                            className={styles.requestButton}
                        >
                            삭제하기
                        </button>
                        {errorMessage &&
                            <div className={styles.errorMessage}>{errorMessage}</div>
                        }
                    </>
                )}
            </div>
        </div>
    );
}

export default DeletePopup;
